import React from "react";
import dayjs from "dayjs";
import useRelativeTimeFormatter from "@Src/hooks/useRelativeTimeFormatter";
import useForceRenderAtInterval from "@Src/hooks/useForceRenderAtInterval";

interface MessageEnvelopeProps {
    senderName: string;
    timestamp: Date;
    useRelativeTime?: boolean;
}

const MessageEnvelope: React.FC<MessageEnvelopeProps> = ({
    senderName,
    timestamp,
    useRelativeTime = false,
}) => {
    const formatRelativeTime = useRelativeTimeFormatter();
    useForceRenderAtInterval(60000, useRelativeTime);

    return (
        <div className="envelope-info">
            <span className="sender-name" data-testid="message-sender-name">
                {senderName}
            </span>
            <span
                data-testid="message-timestamp"
                className={`timestamp ${
                    useRelativeTime ? "relative-time" : ""
                }`}
            >
                {useRelativeTime
                    ? formatRelativeTime(timestamp)
                    : dayjs(timestamp).format("hh:mm:ss A")}
            </span>
        </div>
    );
};

export default MessageEnvelope;
